import axios from "../../utils/axios";

export const getPost = async (id) => {
  const response = await axios.get(`/blogs?id=${id}`);
  return response.data[0];
};

export const updatePost = async (id, data) => {
  const response = await axios.patch(`/blogs/${id}`, data);
  return response.data;
};